<template>
  <div class="filters__wrapper">
    <div class="filters__top">
      <div class="filters__top-left">
        <keyword></keyword>
        <button class="filters__search-btn btn" @click="updateSearchTerm">
          Search
        </button>
      </div>
      <!-- @TODO refactor -->
      <div class="filters__top-right" v-if="isProfessionalDevelopmentResources">
        <filter-dropdown title="Professional Practice" :filters="professional_practice" v-if="hasProfessionalPracticeFilter"></filter-dropdown>
        <filter-dropdown title="Format" :filters="format" v-if="hasFormatFilter"></filter-dropdown>
      </div>
      <div class="filters__top-right" v-else-if="isFederalEducationFunding">
        <filter-dropdown title="Professional Practice" :filters="professional_practice" v-if="hasProfessionalPracticeFilter"></filter-dropdown>
        <filter-dropdown title="Issue" :filters="issue" v-if="hasIssueFilter"></filter-dropdown>
      </div>
      <div class="filters__top-right" v-else-if="isFindYourBook">
        <filter-dropdown title="Theme" :filters="theme"></filter-dropdown>
      </div>
      <div class="filters__top-right" v-else-if="isAnEventCalendar">
        <template v-if="!isAffiliateEvents">
          <filter-dropdown title="State" :filters="state" v-if="hasStateFilter"></filter-dropdown>
        </template>
        <filter-dropdown title="Event Type" :filters="event_type" v-if="hasEventTypeFilter"></filter-dropdown>
        <filter-dropdown title="Region" :filters="region" v-if="hasRegionFilter"></filter-dropdown>
        <filter-dropdown title="Issue" :filters="issue" v-if="hasIssueFilter"></filter-dropdown>
      </div>
      <div class="filters__top-right" v-else-if="isBusinessItems">
        <filter-dropdown title="Type" :filters="business_item_type" v-if="hasBusinessItemTypeFilter"></filter-dropdown>
        <filter-dropdown title="Outcome" :filters="outcome" v-if="hasOutcomeFilter"></filter-dropdown>
      </div>
      <div class="filters__top-right" v-else>
        <filter-dropdown title="Type" :filters="type" v-if="hasTypeFilter"></filter-dropdown>
        <filter-dropdown title="Section" :filters="nea_today_section" v-if="hasSectionFilter"></filter-dropdown>
        <filter-dropdown title="Issue" :filters="issue" v-if="hasIssueFilter"></filter-dropdown>
        <filter-dropdown title="Issue" :filters="federal_legislation_issue" v-if="hasFederalLegislationIssueFilter"></filter-dropdown>
        <filter-dropdown title="Action Type" :filters="action_type" v-if="hasActionTypeFilter"></filter-dropdown>
        <filter-dropdown :title="congressFilterTitle" :filters="congress" v-if="hasCongressFilter"></filter-dropdown>
      </div>
    </div>
    <div class="filters__bottom" v-if="!isProfessionalDevelopmentResources && hasAdditionalFilters">
      <span class="filters__more-label" v-if="!hasQuickActionFilter">Additional Filters:</span>
      <div class="filters__more-wrapper">
        <template v-if="isFindYourBook">
          <filter-dropdown title="Reading Level" :filters="reading_level"></filter-dropdown>
          <filter-dropdown title="Genre" :filters="genre"></filter-dropdown>
        </template>
        <template v-else-if="isAnEventCalendar">
          <filter-dropdown title="Campaign" :filters="campaign" v-if="hasCampaignFilter"></filter-dropdown>
          <filter-dropdown title="Role" :filters="role" v-if="hasRoleFilter"></filter-dropdown>
          <filter-dropdown title="Professional Practice" :filters="professional_practice" v-if="hasProfessionalPracticeFilter"></filter-dropdown>
          <div class="filters__more">
            <checkbox :name="show_past_events['show_past_events'].name" :id="'checkbox-show-past-events'" :item="show_past_events['show_past_events']" :dropdown="false"></checkbox>
          </div>
        </template>
        <template v-else-if="isBusinessItems">
          <filter-dropdown title="Strategic Objective" :filters="strategic_objective" v-if="hasStrategicObjectiveFilter"></filter-dropdown>
        </template>
        <template v-else-if="!isFederalEducationFunding">
          <filter-dropdown title="State" :filters="state" v-if="hasStateFilter && !isRAAgenda && !isCalendarOfEvents"></filter-dropdown>
          <filter-dropdown title="Campaign" :filters="campaign" v-if="hasCampaignFilter"></filter-dropdown>
          <filter-dropdown title="Role" :filters="role" v-if="hasRoleFilter"></filter-dropdown>
          <filter-dropdown title="Year" :filters="year" v-if="hasYearFilter"></filter-dropdown>
          <filter-dropdown title="Professional Practice" :filters="professional_practice" v-if="hasProfessionalPracticeFilter"></filter-dropdown>
          <filter-dropdown title="Academic Subject" :filters="academic_subject" v-if="hasAcademicSubjectFilter"></filter-dropdown>
          <filter-dropdown title="Grade" :filters="grade_level" v-if="hasGradeLevelFilter"></filter-dropdown>
          <div class="filters__more" v-if="hasFromNeaTodayFilter">
            <checkbox :name="nea_today['From NEA Today'].name" :id="'checkbox-from-nea-today'" :item="nea_today['From NEA Today']" :dropdown="false"></checkbox>
          </div>
          <div class="filters__more" v-if="hasQuickActionFilter">
            <checkbox :name="quick_action['quick_action'].name" :id="'checkbox-quick-action'" :item="quick_action['quick_action']" :dropdown="false"></checkbox>
          </div>
          <filter-dropdown :title="positionFilterTitle" :filters="position" v-if="hasPositionFilter"></filter-dropdown>
          <filter-dropdown title="Chamber" :filters="chamber" v-if="hasChamberFilter"></filter-dropdown>
        </template>
        <template v-else>
          <filter-dropdown title="Academic Subject" :filters="academic_subject" v-if="hasAcademicSubjectFilter"></filter-dropdown>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

  import FilterDropdown from "./FilterDropdown";
  import Checkbox from "./Checkbox";
  import Keyword from "./Keyword";
  import {mapGetters} from "vuex";
  import calendar from '@/mixins/calendar'

  //const typeFilters = window.drupalSettings.searchFilters.type
  const articleTypeFilters = window.drupalSettings.searchFilters.article_type
  const resourceTypeFilters = window.drupalSettings.searchFilters.resource_type
  const campaignFilters = window.drupalSettings.searchFilters.campaign
  const issueFilters = window.drupalSettings.searchFilters.issues
  const professionalPracticeFilters = window.drupalSettings.searchFilters.professional_practice
  const formatFilters = window.drupalSettings.searchFilters.professional_development_format
  const academicSubjectFilters = window.drupalSettings.searchFilters.academic_subject
  const gradeLevelFilters = window.drupalSettings.searchFilters.grade_level
  const roleFilters = window.drupalSettings.searchFilters.role
  const yearFilters = window.drupalSettings.searchFilters.year
  const stateFilters = window.drupalSettings.searchFilters.state
  const neaTodayFilters = window.drupalSettings.searchFilters.nea_today
  const searchSettings = window.drupalSettings.searchSettings

  const themeFilters = window.drupalSettings.searchFilters.theme
  const readingLevelFilters = window.drupalSettings.searchFilters.reading_level
  const genreFilters = window.drupalSettings.searchFilters.genre

  const actionTypeFilters = window.drupalSettings.searchFilters.action_type
  const congressFilters = window.drupalSettings.searchFilters.congress
  const positionFilters = window.drupalSettings.searchFilters.position
  const chamberFilters = window.drupalSettings.searchFilters.chamber
  const quickActionFilters = window.drupalSettings.searchFilters.quick_action
  const federalLegislationIssueFilters = window.drupalSettings.searchFilters.federal_legislation_issues
  const eventTypeFilters = window.drupalSettings.searchFilters.event_type
  const regionFilters = window.drupalSettings.searchFilters.region
  const showPastEventsFilters = window.drupalSettings.searchFilters.show_past_events

  const businessItemTypeFilters = window.drupalSettings.searchFilters.business_item_type
  const outcomeFilters = window.drupalSettings.searchFilters.outcome
  const strategicObjectiveFilters = window.drupalSettings.searchFilters.strategic_objective

  const neaTodaySectionFilters = window.drupalSettings.searchFilters.nea_today_section

  const IS_MAIN_SITE = window.drupalSettings.searchSettings.IS_MAIN_SITE
  const SITE_CODE = window.drupalSettings.searchSettings.SITE_CODE

  export default {
    mixins: [calendar],
    name: 'Filters',
    components: {
      FilterDropdown,
      Checkbox,
      Keyword
    },
    created() {
      this.$store.commit('updateAllIssueFilters', issueFilters)
      if (this.route === 'search') {
        this.type = [
          {column: 'Articles', options: articleTypeFilters},
          {column: 'Resources', options: resourceTypeFilters}
        ];
      }
      if (this.isResourceLibrary || this.isToolsAndTips || this.isEdJusticeResourceLibrary) {
        this.type = [{column: null, options: resourceTypeFilters}];
      }
      if (this.route === 'new_from_nea') {
        this.type = [{column: null, options: articleTypeFilters}];
      }
      if (this.route === 'edjustice_see_the_latest') {
        this.type = [{column: null, options: articleTypeFilters}];
      }
    },
    data() {
      return {
        type: [],
        academic_subject: [{column: null, options: academicSubjectFilters}],
        grade_level: [{column: null, options: gradeLevelFilters}],
        issue: [{column: null, options: issueFilters},],
        campaign: [{column: null, options: campaignFilters,}],
        professional_practice: [{column: null, options: professionalPracticeFilters,}],
        format: [{column: null, options: formatFilters,}],
        role: [{column: null, options: roleFilters,}],
        year: [{column: null, options: yearFilters,}],
        state: [{column: null, options: stateFilters}],
        nea_today: neaTodayFilters,
        quick_action: quickActionFilters,
        search_settings: searchSettings,

        theme: [{column: null, options: themeFilters},],
        reading_level: [{column: null, options: readingLevelFilters},],
        genre: [{column: null, options: genreFilters},],
        action_type: [{column: null, options: actionTypeFilters},],
        congress: [{column: null, options: congressFilters},],
        position: [{column: null, options: positionFilters},],
        chamber: [{column: null, options: chamberFilters},],
        federal_legislation_issue: [{column: null, options: federalLegislationIssueFilters},],
        event_type: [{column: null, options: eventTypeFilters},],
        region: [{column: null, options: regionFilters},],
        show_past_events: showPastEventsFilters,

        business_item_type: [{column: null, options: businessItemTypeFilters},],
        outcome: [{column: null, options: outcomeFilters},],
        strategic_objective: [{column: null, options: strategicObjectiveFilters},],

        nea_today_section: [{column: null, options: neaTodaySectionFilters},],

        is_main_site: IS_MAIN_SITE,
        site_code: SITE_CODE
      }
    },
    computed: {
      ...mapGetters({
        searchTerm: 'getSearchTerm',
        autocompleteTerm: 'getAutocompleteTerm',
      }),
      route () {
        return this.$route.name
      },
      isFederalEducationFunding() {
        return this.route === 'federal_education_funding'
      },
      isFindYourBook() {
        return this.route === 'find_your_book'
      },
      isProfessionalDevelopmentResources() {
        return this.route === 'professional_learning_resources'
      },
      isToolsAndTips() {
        return this.route === 'tools_and_tips'
      },
      isBusinessItems() {
        return this.route === 'business_items'
      },
      isResourceLibrary() {
        return this.route === 'resource_library'
      },
      isEdJusticeResourceLibrary() {
        return this.route === 'edjustice_resource_library'
      },
      isTakeAction() {
        return this.route === 'take_action'
      },
      isEdJusticeTakeAction() {
        return this.route === 'edjustice_take_action'
      },
      isEdJusticeSeeTheLatest() {
        return this.route === 'edjustice_see_the_latest'
      },
      hasKeyword() {
        return true;
      },
      hasTypeFilter() {
        return this.search_settings[this.route].type
      },
      hasIssueFilter() {
        return this.search_settings[this.route].issue
      },
      hasStateFilter() {
        return this.search_settings[this.route].state
      },
      hasCampaignFilter() {
        return this.search_settings[this.route].campaign
      },
      hasRoleFilter() {
        return this.search_settings[this.route].role
      },
      hasYearFilter() {
        return this.search_settings[this.route].year
      },
      hasProfessionalPracticeFilter() {
        return this.search_settings[this.route].professional_practice
      },
      hasFromNeaTodayFilter() {
        return this.search_settings[this.route].from_nea_today
      },
      hasFormatFilter() {
        return this.search_settings[this.route].format
      },
      hasAcademicSubjectFilter() {
        return this.search_settings[this.route].academic_subject
      },
      hasGradeLevelFilter() {
        return this.search_settings[this.route].grade_level
      },
      hasActionTypeFilter() {
        return this.search_settings[this.route].action_type
      },
      hasQuickActionFilter() {
        return this.search_settings[this.route].i_am_in_a_hurry
      },
      hasShowPastEventsFilter() {
        return this.search_settings[this.route].show_past_events
      },
      hasCongressFilter() {
        return this.search_settings[this.route].congress
      },
      hasPositionFilter() {
        return this.search_settings[this.route].position
      },
      hasChamberFilter() {
        return this.search_settings[this.route].chamber
      },
      hasFederalLegislationIssueFilter() {
        return this.search_settings[this.route].federal_legislation_issue
      },
      hasEventTypeFilter() {
        return this.search_settings[this.route].event_type
      },
      hasBusinessItemTypeFilter() {
        return this.search_settings[this.route].business_item_type
      },
      hasOutcomeFilter() {
        return this.search_settings[this.route].outcome
      },
      hasStrategicObjectiveFilter() {
        return this.search_settings[this.route].strategic_objective
      },
      hasSectionFilter() {
        return this.search_settings[this.route].nea_today_section
      },
      hasAdditionalFilters() {
        return this.hasStateFilter ||
          this.hasCampaignFilter ||
          this.hasRoleFilter ||
          this.hasYearFilter ||
          (this.hasProfessionalPracticeFilter && !this.isFederalEducationFunding) ||
          this.hasFromNeaTodayFilter ||
          this.hasAcademicSubjectFilter ||
          this.hasGradeLevelFilter ||
          this.isFindYourBook ||
          this.hasQuickActionFilter ||
          this.hasPositionFilter ||
          this.hasChamberFilter ||
          this.hasShowPastEventsFilter ||
          this.hasStrategicObjectiveFilter
      },
      positionFilterTitle() {
        if (this.is_main_site) {
          return "NEA's Position"
        }
        if (this.site_code) {
          return this.site_code.toUpperCase() +"'s Position"
        }
        return "Position"
      },
      congressFilterTitle() {
        if (this.is_main_site) {
          return "Congress"
        } else {
          return "Session"
        }
      }
    },
    methods: {
      updateSearchTerm () {
        this.$store.commit('updateSearchTerm', this.autocompleteTerm)
      }
    }
  }

</script>
